/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrialUpdateRequestStartdate } from './userTrialUpdateRequestStartdate';
import type { UserTrialUpdateRequestDurationDays } from './userTrialUpdateRequestDurationDays';
import type { UserTrialUpdateRequestMessage } from './userTrialUpdateRequestMessage';
import type { UserTrialUpdateRequestCtaLink } from './userTrialUpdateRequestCtaLink';
import type { UserTrialUpdateRequestCtaLabel } from './userTrialUpdateRequestCtaLabel';

/**
 * Parameters for trial user accounts (input/update)
 */
export interface UserTrialUpdateRequest {
  isTrial?: boolean;
  startdate?: UserTrialUpdateRequestStartdate;
  durationDays?: UserTrialUpdateRequestDurationDays;
  message?: UserTrialUpdateRequestMessage;
  ctaLink?: UserTrialUpdateRequestCtaLink;
  ctaLabel?: UserTrialUpdateRequestCtaLabel;
}
